import { Arr, Callback1 } from '@deqo/foundation';
import React, { useMemo } from 'react';
import useResizeObserver from 'use-resize-observer';
import { pxInRem } from '../CodesThatsGottaGoSomewhereElse';

export type BreakpointConfig = Record<string, number>;
export type BreakpointRender = Callback1<JSX.Element, string>;

export interface BreakpointsProps {
    config: BreakpointConfig;
    render: BreakpointRender;
    print?: boolean;
}

const Context = React.createContext(null as string);

const Call = React.memo<{ hit: [string, number], render: BreakpointRender }>(({ hit, render }) =>
    <Context.Provider value={hit[0]}>
        {render(hit[0])}
    </Context.Provider>
);

const Base = React.memo<BreakpointsProps>(({ config, print, render }) => {

    const { ref, width = 1, } = useResizeObserver<HTMLDivElement>();

    const hit = useMemo(() => {
        const bps = Arr.sortBy(Object.entries(config), '1', 'desc');
        return bps.find(x => x[1] <= pxInRem(width));
    }, [config, width]);

    return <div ref={ref}>
        {hit && <Call {...{ hit, render }} />}
        {print && <div>{pxInRem(width)}rem = {hit && hit[0]}</div>}
    </div>;
});

export const Breakpoints = Object.assign(Base, { Context });

export const useBreakpoints = (ref: React.RefObject<HTMLElement>, config: BreakpointConfig) => {
    const { width = 1, } = useResizeObserver<HTMLElement>({ ref });

    const [name, size] = useMemo(() => {
        const bps = Arr.sortBy(Object.entries(config), '1', 'desc');
        return bps.find(x => x[1] <= pxInRem(width)) ?? [];
    }, [config, width]);

    return { name, size };
};
